import type { ManualPromotion } from "@/domain/types";

export const MOCK_MANUAL_PROMOTIONS: ManualPromotion[] = [
  {
    id: "mp-001",
    sku: "sku101",
    skuName: "演示配件101",
    siteId: "site_demo",
    type: "coupon",
    startDate: "2026-07-28",
    endDate: "2026-08-03",
    costMode: "amount",
    amount: 85,
    notes: "夏季大促优惠券",
    createdAt: "2026-07-27T10:00:00Z",
  },
  {
    id: "mp-002",
    sku: "sku101",
    skuName: "演示配件101",
    siteId: "site_demo",
    type: "flash_sale",
    startDate: "2026-08-01",
    endDate: "2026-08-07",
    costMode: "rate",
    rate: 15,
    notes: "8月秒杀周",
    createdAt: "2026-07-30T08:30:00Z",
  },
  {
    id: "mp-003",
    sku: "sku102",
    skuName: "演示配件102",
    siteId: "site_demo",
    type: "offsite_discount",
    startDate: "2026-07-25",
    endDate: "2026-08-10",
    costMode: "amount",
    amount: 120,
    notes: "站外Deal推广",
    createdAt: "2026-07-24T14:00:00Z",
  },
  {
    id: "mp-004",
    sku: "sku103",
    skuName: "演示配件103",
    siteId: "site_demo",
    type: "coupon",
    startDate: "2026-08-05",
    endDate: "2026-08-18",
    costMode: "rate",
    rate: 10,
    notes: "返校季促销券",
    createdAt: "2026-08-02T09:15:00Z",
  },
  {
    id: "mp-005",
    sku: "sku101",
    skuName: "演示配件101",
    siteId: "site_demo",
    type: "coupon",
    startDate: "2026-08-10",
    endDate: "2026-08-17",
    costMode: "amount",
    amount: 60,
    notes: "会员日返场优惠券",
    createdAt: "2026-08-08T11:45:00Z",
  },
];